import ObituaryDisplay from "@components/MainPage/Obituary/ObituaryDisplay";
import React from "react";
import { useTranslation } from "react-i18next";

const Obituary = ({ properties }) => {
	const { t } = useTranslation();
	return (
		<div className="flex h-full w-full md:w-[35%] md:min-w-[400px] flex-shrink-0 flex-col bg-white border-l border-stone-300 shadow-lg">
			<div className="flex w-full bg-[#063447] text-white justify-center items-center py-4 shadow-md">
				<h3 className="text-xl font-extrabold">{t("obituary.preview.title")}</h3>
			</div>
			<ObituaryDisplay properties={properties} />
		</div>
	);
};

export default Obituary;
